import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

import { URL_CONST } from 'utils/urlConsts'

import { selectPartner } from 'containers/App/selectors'

// The shipped wordmark is white (built for the navy top bar). In the new nav
// the logo sits in the theme-following side-nav header, so we paint it as a
// MASK tinted to --color-text — navy on light, light on dark.
//
// Collapsed and expanded MUST use this same asset at the same scale. The
// hexagon is the left ~40px of main-logo.svg (148×44). A separate iron-icon.svg
// extracted from the wordmark read as a different mark when the rail closed.
const WORDMARK_SVG = `${STATIC_BASE_URL}/static/webapp/img/main-logo.svg`
const WORDMARK_HEIGHT = 40
const WORDMARK_WIDTH = Math.round((148 * WORDMARK_HEIGHT) / 44)
const MARK_WIDTH = Math.round((40 * WORDMARK_HEIGHT) / 44)

const LogoFull = styled.span`
  display: block;
  width: ${WORDMARK_WIDTH}px;
  height: ${WORDMARK_HEIGHT}px;
  background-color: var(--color-text);
  -webkit-mask: url('${WORDMARK_SVG}') no-repeat left center / ${WORDMARK_WIDTH}px
    ${WORDMARK_HEIGHT}px;
  mask: url('${WORDMARK_SVG}') no-repeat left center / ${WORDMARK_WIDTH}px ${WORDMARK_HEIGHT}px;
`

const LogoClip = styled.span`
  display: inline-block;
  overflow: hidden;
  width: ${({ $compact }) => ($compact ? `${MARK_WIDTH}px` : `${WORDMARK_WIDTH}px`)};
  height: ${WORDMARK_HEIGHT}px;
  cursor: pointer;
  flex-shrink: 0;
`

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  user-select: none;
  cursor: pointer;
`

/**
 * Logo — clickable IRONSCALES logo that navigates to the home dashboard.
 *
 * For MSP users the partner route is still "home" (the existing navigation
 * uses partners.self when partner is truthy); we replicate that rule here so
 * Logo always behaves as a reliable home link.
 *
 * @param {object}  props
 * @param {boolean} [props.compact=false] - clip to the hexagon; same wordmark asset
 * @param {string}  [props.className]
 */
const Logo = ({ compact = false, className }) => {
  const history = useHistory()
  const partner = useSelector(selectPartner)

  const homePath = partner ? URL_CONST.partners.self : URL_CONST.dashboard.home

  const handleClick = () => {
    history.push(homePath)
  }

  return (
    <LogoWrapper
      id="top-bar-logo"
      className={className}
      onClick={handleClick}
      data-pendo-feature="nav-logo-home"
      role="link"
      tabIndex={0}
      aria-label="Go to home dashboard"
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') handleClick()
      }}
    >
      <LogoClip $compact={compact} aria-hidden="true">
        <LogoFull />
      </LogoClip>
    </LogoWrapper>
  )
}

export default Logo
